export class EventCopy {
  public constructor(
    public EventId: number,
    public InferEventDates: boolean = false,
    public CopyEventItems: boolean = true,
    public CopySponsors: boolean = true,
    public CopyPromoCodes: boolean = true,
    public CopyCustomFields: boolean = true,
    public CopyNotifications: boolean = true,
    public NewStartDate: Date = new Date()
  ) {}
}
